import React from "react";
import { ErrorMessage, useField } from "formik";

export default function TextField({ label, ...props }) {
  const [field, meta] = useField(props);
  const isError = meta.touched && meta.error;

  return (
    <div className="mb-3">
      {label && (
        <label className="form-label fw-semibold" style={{ fontSize: "13.5px" }}>
          {label}
        </label>
      )}
      <input
        {...field}
        {...props}
        autoComplete="off"
        className={`form-control ${isError ? "is-invalid" : ""}`}
        style={{ padding: "10px 14px", borderRadius: "var(--radius-md)" }}
      />
      <ErrorMessage
        component="div"
        name={field.name}
        className="text-danger mt-1"
        style={{ fontSize: "12.5px" }}
      />
    </div>
  );
}
